import { render, staticRenderFns } from "./EditFakeUser.vue?vue&type=template&id=31ad162c&scoped=true"
import script from "./EditFakeUser.vue?vue&type=script&lang=js"
export * from "./EditFakeUser.vue?vue&type=script&lang=js"
import style0 from "./EditFakeUser.vue?vue&type=style&index=0&id=31ad162c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ad162c",
  null
  
)

export default component.exports